import * as types from '../../mutationTypes';

export default {
  /* eslint-disable no-param-reassign */
  [types.RESET_NAVIGATION](state) {
    state.navigation = {};
    state.pageNameMap = {};
    state.fileNameMap = {};
    state.currentPage = '';
  },

  [types.SET_NAVIGATION](state, tocs) {
    // The current modules array existing the vuex store
    const currentModules = Object.keys(state.navigation).map((moduleId) => parseInt(moduleId, 10));
    // The new modules array that is going to update the current modules states
    const tocsModules = tocs.map((data) => data.moduleId);
    // Delete the module key if the the current modules array have extra modules(elements)
    // than the new modules array
    currentModules.forEach((moduleId) => {
      if (!tocsModules.includes(moduleId)) {
        delete state.navigation[moduleId];
        delete state.fileNameMap[moduleId];
        delete state.pageNameMap[moduleId];
        delete state.pageOriginalNameMap[moduleId];
      }
    });

    tocs.forEach((data) => {
      const navigation = {};
      const { moduleId } = data;
      const { toc } = data;
      const { originalToc } = data;
      const map = {};
      const nameMap = {};
      const originalNameMap = {};
      const fileMap = {};
      let maxId = -1;

      // Find the parent lineage of a given toc entry
      function getLineage(tocEntry) {
        const lineage = [];
        let { parentId } = tocEntry;

        // Add the current page - useful for breadcrumbs
        lineage.push({
          name: tocEntry.name,
          path: tocEntry.path
        });

        // Add parents
        while (parentId > -1) {
          lineage.push({
            name: `${map[parentId].name} `,
            path: map[parentId].vpath
          });
          parentId = map[parentId].parentId;
        }

        return lineage.reverse();
      }

      let prevEntry = null;
      // Construct a map from toc entry id to toc entry
      function constructTOCMap(tocEntry) {
        // Cache the largest toc entry id - used later in navigation
        // constuction
        if (tocEntry.id > maxId) maxId = tocEntry.id;

        // NOTE: Page map key values need to be lower case as intra-
        // module links come through as lower case.
        nameMap[tocEntry.name.toLowerCase().trim()] = tocEntry.path;
        // NOTE: File name map values are not case sensitive
        fileMap[tocEntry.path] = tocEntry.name;

        const lineage = getLineage(tocEntry);

        navigation[tocEntry.path] = {
          lineage,
          path: tocEntry.path,
          previous: prevEntry ? prevEntry.path : '',
          next: '',
          creatorId: tocEntry.creatorId,
          visible: tocEntry.selected && tocEntry.visible,
          public: tocEntry.public
        };

        if (prevEntry) navigation[prevEntry.path].next = tocEntry.path;
        prevEntry = tocEntry;

        if (tocEntry.children && tocEntry.children.length > 0) {
          map[tocEntry.id] = tocEntry;

          tocEntry.children.forEach((child) => {
            constructTOCMap(child);
          });
        }
        /* Skip parent method
                if (!(tocEntry.children && tocEntry.children.length > 0)) {
                    // Cache the largest toc entry id - used later in navigation
                    // constuction
                    if (tocEntry.id > maxId) maxId = tocEntry.id;

                    // NOTE: Page map key values need to be lower case as intra-
                    // module links come through as lower case.
                    nameMap[tocEntry.name.toLowerCase().trim()] = tocEntry.path;
                    // NOTE: File name map values are not case sensitive
                    fileMap[tocEntry.path] = tocEntry.name;

                    const lineage = getLineage(tocEntry);

                    navigation[tocEntry.path] = {
                        lineage,
                        path: tocEntry.path,
                        previous: prevEntry ? prevEntry.path : '',
                        next: ''
                    };
                    if (prevEntry) navigation[prevEntry.path].next = tocEntry.path;
                    prevEntry = tocEntry;
                } else {
                    map[tocEntry.id] = tocEntry;

                    tocEntry.children.forEach((child) => {
                        constructTOCMap(child);
                    });
                }
                */
      }

      // used for child site, myabe some pages are locked by parent, we still need the path
      function constructOriginalTOCMap(tocEntry) {
        originalNameMap[tocEntry.name.toLowerCase().trim()] = tocEntry.path;
        if (tocEntry.children && tocEntry.children.length > 0) {
          tocEntry.children.forEach((child) => {
            constructOriginalTOCMap(child);
          });
        }
      }

      if (toc) constructTOCMap(toc);
      if (originalToc) constructOriginalTOCMap(originalToc);

      state.navigation[moduleId] = navigation;
      state.pageNameMap[moduleId] = nameMap;
      state.pageOriginalNameMap[moduleId] = originalNameMap;
      state.fileNameMap[moduleId] = fileMap;
    });
  },

  [types.SET_CURRENT_PAGE](state, page) {
    state.currentPage = page;
  },

  [types.SET_NAVIGATION_OVER](state, over) {
    state.navigationSet = over;
  }
  /* eslint-enable no-param-reassign */
};
